import { FC } from 'react'
import { Icon } from '@chakra-ui/react'

import { uniqueId } from '@/services'

export const Doc: FC = () => {
  const id = `clip${uniqueId()}`
  return (
    <Icon
      width="70px"
      height="70px"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3171_3668)">
        <path
          d="M43.75 2.1875V19.6875H61.25"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
        />
        <path
          d="M61.25 28.4375V19.6875L43.75 2.1875H8.75V28.4375"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8.75 59.0625V67.8125H61.25V59.0625"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M27.7812 43.75C27.7812 45.9375 27.125 47.4688 26.0312 48.5625C24.9375 49.6563 23.4062 50.3125 21.2187 50.3125H17.2812V37.8438H21.6562C23.625 37.8438 25.1562 38.2813 26.25 39.375C27.3438 40.4688 27.7812 41.7813 27.7812 43.75ZM24.2813 43.9688C24.2813 42.875 24.0625 42 23.625 41.3438C23.1875 40.6875 22.5312 40.4688 21.6562 40.4688H20.5625V47.4688H21.2187C22.3125 47.4688 22.9687 47.25 23.4062 46.5938C23.8437 45.9375 24.2813 45.0625 24.2813 43.9688Z"
          fill="white"
        />
        <path
          d="M41.7813 43.9688C41.7813 46.1562 41.3437 47.6875 40.25 48.7812C39.1562 49.875 37.625 50.5312 35.6562 50.5312C33.6875 50.5312 32.1562 49.875 31.0625 48.7812C29.9687 47.6875 29.5312 46.1562 29.5312 43.9688C29.5312 41.7812 29.9687 40.25 31.0625 39.1562C32.1562 38.0625 33.6875 37.4062 35.6562 37.4062C37.625 37.4062 39.1562 37.8437 40.25 38.9375C41.3437 40.0312 41.7813 42 41.7813 43.9688ZM33.25 43.9688C33.25 46.375 34.125 47.6875 35.875 47.6875C36.75 47.6875 37.4062 47.4687 37.8437 46.8125C38.2812 46.1562 38.5 45.2812 38.5 43.9688C38.5 42.6562 38.2812 41.7812 37.8437 41.125C37.4062 40.4687 36.75 40.25 35.875 40.25C34.125 40.4687 33.25 41.5625 33.25 43.9688Z"
          fill="white"
        />
        <path
          d="M49.6563 40.4688C48.7813 40.4688 48.125 40.9062 47.6875 41.5625C47.25 42.2188 47.0313 43.0938 47.0313 44.1875C47.0313 46.5938 47.9062 47.6875 49.875 47.6875C50.5312 47.6875 50.9688 47.6875 51.4063 47.4688C51.8438 47.25 52.5 47.0312 52.9375 46.8125V49.6563C51.8438 50.0938 50.75 50.3125 49.4375 50.3125C47.4688 50.3125 46.1563 49.875 45.0625 48.5625C43.9688 47.25 43.5312 45.9375 43.5312 43.75C43.5312 42.4375 43.75 41.3437 44.1875 40.25C44.625 39.1562 45.2813 38.5 46.375 38.0625C47.4688 37.625 48.3438 37.1875 49.6563 37.1875C50.9688 37.1875 52.2813 37.4062 53.5938 38.0625L52.5 41.125C52.0625 40.9062 51.625 40.6875 51.1875 40.6875C50.75 40.6875 50.0938 40.4688 49.6563 40.4688Z"
          fill="white"
        />
        <path
          d="M67.8125 28.4375H2.1875V59.0625H67.8125V28.4375Z"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="70px" height="70px" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}
